"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRatingAndReviewDialogEvent = void 0;
var OpenRatingAndReviewDialog = _interopRequireWildcard(require("@ori-events/open-rating-and-review-dialog"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useRatingAndReviewDialogEvent = () => {
  const [eventData, setEventData] = (0, _react.useState)();
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  const onOpenRatingAndReviewDialog = (0, _react.useCallback)(({
    detail
  }) => {
    const {
      orderId: orderIdFromEvent,
      reviewId: reviewIdFromEvent
    } = detail;
    if (!!reviewIdFromEvent || !!orderIdFromEvent) {
      setEventData(detail);
      onOpen();
    }
  }, [onOpen]);
  const onCloseRatingAndReviewDialog = (0, _react.useCallback)(() => {
    onClose();
    setEventData(undefined);
  }, [onClose]);
  const events = (0, _react.useMemo)(() => [{
    name: OpenRatingAndReviewDialog.Name,
    listener: onOpenRatingAndReviewDialog
  }], [onOpenRatingAndReviewDialog]);
  (0, _presentationHooks.useGlobalEvents)(events);
  const {
    orderId,
    productCode,
    reviewId,
    onSuccessCreate,
    onSuccessDelete,
    onSuccessUpdate
  } = eventData ?? {};
  return (0, _react.useMemo)(() => ({
    orderId,
    productCode,
    reviewId,
    initialOpenDone,
    open,
    onClose: onCloseRatingAndReviewDialog,
    onSuccessCreate,
    onSuccessDelete,
    onSuccessUpdate
  }), [initialOpenDone, onCloseRatingAndReviewDialog, onSuccessCreate, onSuccessDelete, onSuccessUpdate, open, orderId, productCode, reviewId]);
};
exports.useRatingAndReviewDialogEvent = useRatingAndReviewDialogEvent;
